import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';

import 'amfe-flexible/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/theme/index.css';
import { Picker, NavBar, Toast, Switch, Form, Button, Field, Dialog, Circle, List, Popup, Empty, Tab, Tabs, Cell, CellGroup, ActionSheet, DatetimePicker, Popover, DropdownMenu, DropdownItem, Search, Pagination } from 'vant';
import "vant/lib/index.css";
import Video from 'video.js'
import 'video.js/dist/video-js.css'

import '@/assets/iconfont/iconfont.css'

import utils from '@/utils/util/index.js';


// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()

Vue.prototype.$u = utils;
Vue.prototype.$video = Video

ElementUI.Select.computed.readonly = function () {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return !(this.filterable || this.multiple || !isIE) && !this.visible;
};

Vue.use(ElementUI);

Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Switch);
Vue.use(Form);
Vue.use(Button);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Circle);
Vue.use(List);
Vue.use(Popup);
Vue.use(Empty);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(ActionSheet);
Vue.use(DatetimePicker);
Vue.use(Popover);
Vue.use(Picker);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Search);
Vue.use(Pagination);
Vue.use(preview);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
